<template>
  <main>
    <Topbar v-if="!isLogin"/>
    <slot/>
    <Footer v-if="!isLogin"/>
  </main>
</template>

<script>
  import Topbar from "@/components/core/Topbar";
  import Footer from "@/components/core/Footer";
  export default {
    components: {
      Topbar,
      Footer,
    },
    computed: {
      isLogin() {
        return this.$route.name == "Login";
      },
    },
  };
</script>